import React, { useEffect, useState } from 'react';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import AdminMobileSearchInput from 'routes/adminMobile/components/common/AdminMobileSearchInput';
import AdminMobileRegisterBtn from 'routes/adminMobile/components/common/AdminMobileRegisterBtn';
import AdminMobileEventList from 'routes/adminMobile/components/AdminMobileEventList';

// 이벤트 테스트 데이터
import testEventData from 'routes/adminMobile/commonVar/testEventData';

const AdminMobileStoreEvent = () => {
    // 검색어 상태 추가
    const [searchKeyword, setSearchKeyword] = useState('');
    

    // 필터링된 이벤트 리스트를 상태로 관리
    const[filteredEvent, setFilteredEvent] = useState([]);

    // 검색 컴포넌트 기능
    // 검색어 입력 핸들러
    const handleSearchChange = (inputValue) => {
        setSearchKeyword(inputValue);
    };
    

    useEffect(() => {
        let filtered = testEventData;
    
        // 검색어가 있으면 해당 검색어를 포함하는 공지사항 필터링
        if (searchKeyword) {
            filtered = filtered.filter(event =>
                event.title.toLowerCase().includes(searchKeyword.toLowerCase()) ||
                event.startDate.startsWith(searchKeyword.toLowerCase()) ||
                event.endDate.startsWith(searchKeyword.toLowerCase())
            );
        }
    
        setFilteredEvent(filtered);
    }, [searchKeyword]);

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>이벤트 관리</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 검색 창 */}
                        <AdminMobileSearchInput placeholder="이벤트 명, 기간을 검색해보세요." onSearch={handleSearchChange} />
                    </FlexChild>
                    <FlexChild>
                        {/* 이벤트 관리 리스트 */}
                        <AdminMobileEventList events={filteredEvent} />
                    </FlexChild>
                </VerticalFlex>
                {/* 등록 페이지 이동 버튼 */}
                <AdminMobileRegisterBtn to="/admin/mobile/event/register" />
            </Container>
        </div>
    );
};

export default AdminMobileStoreEvent;